"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillOfMaterial = void 0;
const common_1 = require("../../common");
const product_model_1 = require("./product.model");
class BillOfMaterial extends common_1.MongoDocument {
}
exports.BillOfMaterial = BillOfMaterial;
//# sourceMappingURL=bill-of-material.model.js.map